module.exports = __webpack_public_path__ + "static/media/dec2024-3.bc7cafb9.webp";